import isbot from 'isbot';

function isBot() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : typeof navigator === "undefined" ? null : navigator.userAgent;
    return isbot(userAgent);
}
function isMobile() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : typeof navigator === "undefined" ? null : navigator.userAgent;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return /iPhone|iPad|iPod|Android/i.test(userAgent);
}
function isMobileAndNotTablet() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : typeof navigator === "undefined" ? null : navigator.userAgent;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return /(?:iPhone|iPod|Android)(?!Tablet|iPad)/i.exec(userAgent) != null;
}
/* eslint-disable @typescript-eslint/naming-convention */ function isIOS() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : typeof navigator === "undefined" ? null : navigator.userAgent;
    /* eslint-disable @typescript-eslint/dot-notation */ // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return /iPad|iPhone|iPod/.test(userAgent) && window["MSStream"] == null;
}
function isInternetExplorer() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : typeof navigator === "undefined" ? null : navigator.userAgent;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return /MSIE|Trident/i.test(userAgent);
}
function isFirefox() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : typeof navigator === "undefined" ? null : navigator.userAgent;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return /firefox/i.test(userAgent);
}
function isDesktopSafari() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : typeof navigator === "undefined" ? null : navigator.userAgent, vendor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : typeof navigator === "undefined" ? "" : navigator.vendor;
    return(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    /Safari/i.test(userAgent) && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    !/Mobi|Android/i.test(userAgent) && // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    vendor.includes("Apple Computer"));
}

export { isBot, isDesktopSafari, isFirefox, isIOS, isInternetExplorer, isMobile, isMobileAndNotTablet };
